import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject } from 'rxjs';
import { SessionMonitorService } from '../session-monitor/session-monitor.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly userNameSubject = new BehaviorSubject<string | null>(null);
  constructor(private readonly msalService: MsalService, private readonly sessionMonitorService: SessionMonitorService) { }
  async handleRedirect(): Promise<void> {
    try {
      const result = await this.msalService.instance.handleRedirectPromise();
      if (result && result.account) {
        this.msalService.instance.setActiveAccount(result.account);
        localStorage.setItem('token', JSON.stringify(result.idToken));
        localStorage.setItem('accessToken', JSON.stringify(result.accessToken));
        this.sessionMonitorService.startMonitoring();
      }
        // Only call login if there's no active account after handling redirects
      if (!this.isLoggedIn()) {
        this.login();
      }
    } catch (error) {
      console.error('MSAL redirect error:', error);
    }
  }

  login(): void {
    this.msalService.loginRedirect({
      scopes: ['openid', 'profile', 'email']
    });
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getActiveAccount() != null;
  }

  updateUserName(): void {
    const account = this.msalService.instance.getActiveAccount();
    const currentName = account?.name || account?.username;
    this.userNameSubject.next(currentName || null);
  }
}
